import React from "react";
import PropTypes from "prop-types";
import Chip from "@mui/material/Chip";
import { styled } from "@mui/material/styles";
import { withTransientProps } from "core/utils/transientProps";

const RED = "#ff0000";
const GREEN = "#92d050";
const YELLOW = "#ffc30b";
const YELLOWGREEN = "rgb(202, 202, 40)";
const GRAY = "#e0e0e0";

const workOrderStatusColors = {
  Approved: GREEN,
  Canceled: RED,
  Closed: GRAY,
  Completed: GREEN,
  "In Planning": YELLOWGREEN,
  "In Progress": YELLOWGREEN,
  Rejected: RED,
  Request: YELLOWGREEN,
  Scheduled: YELLOWGREEN,
  "Waiting Approval": YELLOW,
  Hold: YELLOW,
  "Ready to Schedule": GREEN,
  "Awaiting Sync": YELLOW,
  "Sync Failed": RED
};

export function WorkStatusChip({ workOrder }) {
  return (
    <StatusChip
      $chipColour={workOrderStatusColors[workOrder] ?? GRAY}
      label={workOrder ?? "None"}
    />
  );
}

const StatusChip = styled(Chip, withTransientProps)`
  background-color: ${({ $chipColour }) => $chipColour};
  color: ${({ theme, $chipColour }) =>
    theme.palette.getContrastText($chipColour)};
`;

WorkStatusChip.propTypes = {
  workOrder: PropTypes.string
};
